<template>
  <a
    ref="btn"
    href="javascript:"
    :class="{[$props.btnClass]: true, 'm-dropdown--open': open}"
    :disable="$props.disabled"
    @click="toggle"
  >
    <slot name="btn" />
  </a>
  <div class="m-dropdown__wrapper">
    <slot name="dropdown" />
  </div>
</template>
<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        btnClass: {
            type: String,
            required: false,
            default: 'm-nav__link m-dropdown__toggle',
        },
    },
    data() {
        return {
            open: false,
        };
    },
    mounted() {
        document.addEventListener( 'click', ( event ) => {
            if ( !event.target || !( event.target instanceof Element ) ) {
                return;
            }

            const target = event.target;

            if ( target.closest( '.m-dropdown' ) ) {
                return;
            }

            this.hide();
        } );
    },
    methods: {
        toggle( event ) {
            event.preventDefault();

            if ( this.open ) {
                this.hide();
            } else {
                this.show();
            }
        },
        show() {
            if ( !this.$refs.btn ) {
                return;
            }

            document.querySelectorAll( '.m-dropdown.m-dropdown--open' ).forEach( ( dropdown ) => {
                dropdown.classList.remove( 'm-dropdown--open' );
            } );

            const parent = this.$refs.btn.closest( '.m-dropdown' );

            if ( !parent ) {
                return;
            }

            parent.classList.add( 'm-dropdown--open' );
            this.open = true;
        },
        hide() {
            if ( !this.$refs.btn ) {
                return;
            }

            const parent = this.$refs.btn.closest( '.m-dropdown' );

            if ( !parent ) {
                return;
            }

            parent.classList.remove( 'm-dropdown--open' );
            this.open = false;
        },
    },
};
</script>
